/* @flow */

import React from 'react';
import { Header, Message, Segment, Label, Icon, Grid } from 'semantic-ui-react';
import RichTextItem from 'shared/components/RichTextItem';
import { EditorState } from 'draft-js';
import { htmlToState, linkDecorator } from 'utils/richtext';
import { MAIL_CONTACT_BLOCKTYPE } from './constants';

type Props = {
  block: EditorialContactBlock,
};

const View = ({ block }: Props) => {
  const targetIcon = block.type === MAIL_CONTACT_BLOCKTYPE
    ? 'mail square'
    : 'phone square';
  const blockLabel = block.type === MAIL_CONTACT_BLOCKTYPE
    ? 'Contact par email'
    : 'Contact par téléphone';

  const stateFromBlockContent = block.content
    ? htmlToState(block.content)
    : EditorState.createEmpty(linkDecorator);

  if (block.target) {
    return (
      <Segment padded>
        <Label attached="top">{blockLabel}</Label>
        <Grid padded>
          <Grid.Row>
            <Header>
              <Icon name={targetIcon} />
              {block.target}
            </Header>
          </Grid.Row>
          <Grid.Row>
            {block.text && 'Titre: ' + block.text}
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width="sixteen">
              {block.content &&
                <RichTextItem parentState={stateFromBlockContent} readOnly />}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }

  return <Message icon="info" header="Aucun contact spécifié" />;
};

export default View;



// WEBPACK FOOTER //
// ./src/modules/edito/plugins/contact/View.js